import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { style: { "margin-top": "-20px" } };
const _hoisted_2 = { style: { "margin-top": "50px" } };
const _hoisted_3 = {
    key: 1,
    class: "website-details-wrapper"
};
const _hoisted_4 = {
    key: 2,
    class: "no-website-found"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h1", null, "No website found", -1);
const _hoisted_6 = [
    _hoisted_5
];
import { onBeforeMount, ref, watch, } from "vue";
import { useRoute } from "vue-router";
import OneDeskReportTable from "@/components/templates/Websites/OneDeskReportTable.vue";
import WebsiteInfo from "@/components/templates/Websites/WebsiteInfo.vue";
import { getWebsiteBySlug, } from "@/repositories/inventory.repository";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { useStore } from "vuex";
import { AllActionTypes } from "@/store/action-types";
import OneDeskSkeleton from "@/components/atoms/OneDeskSkeleton.vue";
import WebsiteDisplayHeroModule from "@/components/templates/Websites/WebsiteDisplayHeroModule.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WebsiteDetails',
    setup(__props) {
        const store = useStore();
        const route = useRoute();
        const websiteDetails = ref();
        const loading = ref(true);
        const siteFrameworkBackGroundColor = ref("");
        const displaySiteFramework = ref("");
        const getWebsiteDetailsAsync = async () => {
            loading.value = true;
            websiteDetails.value = await getWebsiteBySlug(route.params.slug);
            loading.value = false;
        };
        watch(route.params.slug, (currentValue) => {
            if (currentValue && currentValue != "")
                getWebsiteDetailsAsync();
        });
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.NAVIGATIONMENU);
            await getWebsiteDetailsAsync();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(WebsiteDisplayHeroModule, { websiteDetails: websiteDetails.value }, null, 8, ["websiteDetails"]),
                _createElementVNode("div", _hoisted_2, [
                    (loading.value)
                        ? (_openBlock(), _createBlock(OneDeskSkeleton, { key: 0 }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(WebsiteInfo, {
                                class: "page-container",
                                "website-details": websiteDetails.value,
                                siteFrameworkBackGroundColor: siteFrameworkBackGroundColor.value,
                                displaySiteFramework: displaySiteFramework.value
                            }, null, 8, ["website-details", "siteFrameworkBackGroundColor", "displaySiteFramework"]),
                            _createVNode(OneDeskReportTable, { data: websiteDetails.value }, null, 8, ["data"])
                        ])),
                    (!websiteDetails.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
